module.exports = __webpack_public_path__ + "static/media/wavm8s-2017-end-of-year-edition.3f55753.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-2017-end-of-year-edition.mp3
// module id = aqju
// module chunks = 0